import { render, staticRenderFns } from "./TemplateSearchNodataMergeSearch.vue?vue&type=template&id=6368d972&scoped=true"
import script from "./TemplateSearchNodataMergeSearch.vue?vue&type=script&lang=js"
export * from "./TemplateSearchNodataMergeSearch.vue?vue&type=script&lang=js"
import style0 from "./TemplateSearchNodataMergeSearch.vue?vue&type=style&index=0&id=6368d972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6368d972",
  null
  
)

export default component.exports